// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m_d46a4834 {
  position: relative;
  border: calc(0.0625rem * var(--mantine-scale)) dashed;
  color: var(--mantine-color-text);
  padding: var(--mantine-spacing-md);
  border-radius: var(--dropzone-radius);
  cursor: pointer;
  user-select: none;
  transition:
    background-color 100ms ease,
    border-color 100ms ease;
}

  .m_d46a4834:where([data-loading]),
  .m_d46a4834:where(:not([data-activate-on-click])) {
    cursor: default;
  }

  :where([data-mantine-color-scheme='light']) .m_d46a4834 {
    background-color: var(--mantine-color-white);
    border-color: var(--mantine-color-gray-4);
}

  :where([data-mantine-color-scheme='dark']) .m_d46a4834 {
    background-color: var(--mantine-color-dark-6);
    border-color: var(--mantine-color-dark-4);
}

  @media (hover: hover) {
      :where([data-mantine-color-scheme='light']) .m_d46a4834:hover:where([data-activate-on-click]:not([data-loading])) {
        background-color: var(--mantine-color-gray-0);
  }

      :where([data-mantine-color-scheme='dark']) .m_d46a4834:hover:where([data-activate-on-click]:not([data-loading])) {
        background-color: var(--mantine-color-dark-5);
  }
}

  @media (hover: none) {
      :where([data-mantine-color-scheme='light']) .m_d46a4834:active:where([data-activate-on-click]:not([data-loading])) {
        background-color: var(--mantine-color-gray-0);
  }

      :where([data-mantine-color-scheme='dark']) .m_d46a4834:active:where([data-activate-on-click]:not([data-loading])) {
        background-color: var(--mantine-color-dark-5);
  }
}

  .m_d46a4834:where([data-accept]) {
    background-color: var(--dropzone-accept-bg);
    border-color: var(--dropzone-accept-bg);
    color: var(--dropzone-accept-color);
  }

  .m_d46a4834:where([data-reject]) {
    background-color: var(--dropzone-reject-bg);
    border-color: var(--dropzone-reject-bg);
    color: var(--dropzone-reject-color);
  }

.m_b85f7144 {
  pointer-events: none;
  user-select: none;
}

.m_b85f7144:where([data-enable-pointer-events]) {
    pointer-events: all;
  }

.m_96f6e9ad {
  position: fixed;
  inset: 0;
  background-color: var(--mantine-color-body);
  display: flex;
  flex-direction: column;
  padding: var(--mantine-spacing-xs);
  transition: opacity 100ms ease;
}

.m_96f6e9ad .m_7946116d {
    flex: 1;
  }
`, "",{"version":3,"sources":["webpack://./node_modules/@mantine/dropzone/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB;;2BAEyB;AAC3B;;EAEE;;IAEE,eAAe;EACjB;;EAEA;IACE,4CAA4C;IAC5C,yCAAyC;AAC7C;;EAEE;IACE,6CAA6C;IAC7C,yCAAyC;AAC7C;;EAEE;MACI;QACE,6CAA6C;EACnD;;MAEI;QACE,6CAA6C;EACnD;AACF;;EAEE;MACI;QACE,6CAA6C;EACnD;;MAEI;QACE,6CAA6C;EACnD;AACF;;EAEE;IACE,2CAA2C;IAC3C,uCAAuC;IACvC,mCAAmC;EACrC;;EAEA;IACE,2CAA2C;IAC3C,uCAAuC;IACvC,mCAAmC;EACrC;;AAEF;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;IACI,mBAAmB;EACrB;;AAEF;EACE,eAAe;EACf,QAAQ;EACR,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;IACI,OAAO;EACT","sourcesContent":[".m_d46a4834 {\n  position: relative;\n  border: calc(0.0625rem * var(--mantine-scale)) dashed;\n  color: var(--mantine-color-text);\n  padding: var(--mantine-spacing-md);\n  border-radius: var(--dropzone-radius);\n  cursor: pointer;\n  user-select: none;\n  transition:\n    background-color 100ms ease,\n    border-color 100ms ease;\n}\n\n  .m_d46a4834:where([data-loading]),\n  .m_d46a4834:where(:not([data-activate-on-click])) {\n    cursor: default;\n  }\n\n  :where([data-mantine-color-scheme='light']) .m_d46a4834 {\n    background-color: var(--mantine-color-white);\n    border-color: var(--mantine-color-gray-4);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_d46a4834 {\n    background-color: var(--mantine-color-dark-6);\n    border-color: var(--mantine-color-dark-4);\n}\n\n  @media (hover: hover) {\n      :where([data-mantine-color-scheme='light']) .m_d46a4834:hover:where([data-activate-on-click]:not([data-loading])) {\n        background-color: var(--mantine-color-gray-0);\n  }\n\n      :where([data-mantine-color-scheme='dark']) .m_d46a4834:hover:where([data-activate-on-click]:not([data-loading])) {\n        background-color: var(--mantine-color-dark-5);\n  }\n}\n\n  @media (hover: none) {\n      :where([data-mantine-color-scheme='light']) .m_d46a4834:active:where([data-activate-on-click]:not([data-loading])) {\n        background-color: var(--mantine-color-gray-0);\n  }\n\n      :where([data-mantine-color-scheme='dark']) .m_d46a4834:active:where([data-activate-on-click]:not([data-loading])) {\n        background-color: var(--mantine-color-dark-5);\n  }\n}\n\n  .m_d46a4834:where([data-accept]) {\n    background-color: var(--dropzone-accept-bg);\n    border-color: var(--dropzone-accept-bg);\n    color: var(--dropzone-accept-color);\n  }\n\n  .m_d46a4834:where([data-reject]) {\n    background-color: var(--dropzone-reject-bg);\n    border-color: var(--dropzone-reject-bg);\n    color: var(--dropzone-reject-color);\n  }\n\n.m_b85f7144 {\n  pointer-events: none;\n  user-select: none;\n}\n\n.m_b85f7144:where([data-enable-pointer-events]) {\n    pointer-events: all;\n  }\n\n.m_96f6e9ad {\n  position: fixed;\n  inset: 0;\n  background-color: var(--mantine-color-body);\n  display: flex;\n  flex-direction: column;\n  padding: var(--mantine-spacing-xs);\n  transition: opacity 100ms ease;\n}\n\n.m_96f6e9ad .m_7946116d {\n    flex: 1;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
